import type { User } from '../types/context.types';
import type { UserTier } from '../types/api.types';

const REGISTERED_PROVIDERS = new Set(['email', 'google', 'github', 'linkedin']);

function userProvider(user: User | null): string | undefined {
  return (user as { provider?: string } | null)?.provider;
}

/** True when the session is a Studio guest (never shown on Academy navbar). */
export function isGuestSession(user: User | null, userTier: UserTier | null, isLoggedIn: boolean): boolean {
  if (!isLoggedIn) return false;
  const provider = userProvider(user);
  if (provider === 'guest') return true;
  if (provider != null && REGISTERED_PROVIDERS.has(provider)) return false;
  return userTier === 'guest';
}

/** True when the user has a registered (non-guest) Academy session. */
export function isRegisteredSession(user: User | null, userTier: UserTier | null, isLoggedIn: boolean): boolean {
  if (!isLoggedIn || !user) return false;
  if (isGuestSession(user, userTier, isLoggedIn)) return false;
  const provider = userProvider(user);
  if (provider != null && REGISTERED_PROVIDERS.has(provider)) return true;
  if (userTier === 'free' || userTier === 'paid') return true;
  return false;
}
